<template lang="pug">
  BaseFixCenter(v-model="visible" :title="title" :w="w" :h="h" :noBtm="noBtm")
    component(:is="cpName" :curItem="curItem")
    template(#footer v-if="confirmBtnLabel || cancelBtnLabel")
      .footer
        .el-btn.red(v-if="confirmBtnLabel" @click="confirmAction") {{confirmBtnLabel}}
        .el-btn(v-if="cancelBtnLabel" @click="closeDialog") {{cancelBtnLabel}}
</template>

<script>
  export default {
    name: 'ConfirmDialog',
    props: {
      title: {
        type: String,
        default: '温馨提示'
      },
      confirmBtnLabel: {
        type: String,
        default: ''
      },
      cancelBtnLabel : {
        type: String,
        default: ''
      },
      w: {
        type: [String, Number],
        default: 400
      },
      h: {
        type: [String, Number],
        default: 300
      },
      noBtm: {
        type: Boolean,
        default: false
      } 
    },
    data () {
      return {
        visible: true,
        curItem: {}
      }
    },
    methods: {
      async confirmAction () {
        this.rs(this.curItem)
        this.closeDialog()
      }
    }
  }
</script>

<style lang="scss">
.confirm-dialog {
  &.el-dialog {
    .footer {
      text-align: center;
    }
  }
}
</style>
